import React from "react";
import Map from './Map';
import useFetch from "../../../../commons/useFetch";
import { Select, Input, Form } from "antd";
function ContactContent() {
    const key = "AIzaSyAwUUGIMXTOZEX_rtcZj1IyvTOqsA2sts4";
    const { data: hotels } = useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/hotels');
    const { Option } = Select;
    const { TextArea } = Input;
    return (
        <div className="contactContent">
            <div className="contactInfo">
                <div className="container">
                    <div className="title">
                        <p>Mandala liên hệ</p>
                        <h5>Trụ sở chính Mandala Hotels</h5>
                    </div>
                    <div className="row rowBox">
                        <div className="col-lg-4 col-12 colBox">
                            <img className="img-fluid icon" src="/images/locationCT.png" alt="" />
                            <p>Địa chỉ</p>
                            <h5>Tầng 3, TTTM Grand Plaza, số 117 Trần Duy Hưng, P. Trung Hòa, Q. Cầu Giấy, Hà Nội</h5>
                        </div>
                        <div className="col-lg-4 col-12 colBox">
                            <img className="img-fluid icon" src="/images/phone-call.png" alt="" />
                            <p>Điện thoại</p>
                            <h5> 0222 386 88 66</h5>
                        </div>
                        <div className="col-lg-4 col-12 colBox">
                            <img className="img-fluid icon"  src="/images/email.png" alt="" />
                            <p>Email</p>
                            <h5>welcome@mandalahotel.com.vn</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div className="map">
                <Map
                    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${key}&callback=initMap`}
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={
                        <div
                            style={{
                                height: `500px`,
                                margin: `auto`,
                            }}
                        />
                    }
                    mapElement={<div style={{ height: `100%` }} />}
                />
            </div>
            <div className="formContact">
                <div className="container">
                    <div className="title"><p>Để lại lời nhắn cho chúng tôi</p></div>
                    <div className="formBox">
                        <div className="row rowBox">
                            <div className="col-lg-7 col-12 col-md-7 colBox">
                                <img className="img-fluid image" src="/images/slide-1.png" alt="" />
                            </div>
                            <div className="col-lg-5 col-12 col-md-5 colBox ">
                                <Form
                                    className="formInfo"
                                >
                                    <Form.Item className="formInput "
                                        label="Họ và tên"
                                        name="fullName"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please input your username!',
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item className="formInput"
                                        label="Nhập số điện thoại hoặc email"
                                        name="email"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please input your phone or your email!',
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item className="formInput"
                                        label="Gửi tới"
                                        name="fullName"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please input your username!',
                                            },
                                        ]}
                                    >
                                        <Select >
                                            <Option>Trụ sở chính</Option>
                                            {hotels.map(item => {
                                                return (
                                                    <Option>
                                                        {item.name}
                                                    </Option>
                                                )
                                            })}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item className="formInput"
                                        label="Nội dung"
                                        name="fullName"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please input your content!',
                                            },
                                        ]}
                                    >
                                        <TextArea rows={4} />
                                    </Form.Item>
                                    <Form.Item

                                    >
                                        <button className="btnStyle" >
                                            Gửi
                                        </button>
                                    </Form.Item>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default ContactContent;